module.exports = __webpack_public_path__ + "static/media/pic_default_res.c0bdc453.png";